import { PathType } from "./PathType";

export const CoordinatorPath: PathType[] = [
  {
    path: "/coordinator",
    label: "Home",
    icon: "../../../../../assets/home.png"
  },
];
